import { render } from "./DashboardChartCard.vue?vue&type=template&id=3cdf071d&scoped=true"
import script from "./DashboardChartCard.vue?vue&type=script&lang=js"
export * from "./DashboardChartCard.vue?vue&type=script&lang=js"

import "./DashboardChartCard.vue?vue&type=style&index=0&id=3cdf071d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdf071d"]])

export default __exports__